module.exports = __webpack_public_path__ + "static/media/microblog-gif-500.03314125.gif";